
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"1 0 14 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.368.834h0l.004-.002a.965.965 0 01.78 0h0l.004.002 6.037 2.682s0 0 0 0c.351.156.581.51.581.893v4.054c0 4.407-3.015 8.502-7.012 9.575C3.765 16.965.75 12.87.75 8.463V4.409a.982.982 0 01.58-.893L7.369.834z","stroke":"currentColor","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M5.486 13.027l-2.234-2.234a.86.86 0 111.216-1.216l1.63 1.621 5.072-5.07a.859.859 0 111.216 1.215l-5.684 5.684a.859.859 0 01-1.216 0z","fill":"currentColor"}})])
          )
        }
      }
    